/**
 * Turn a failed profitability response into an Error a page can show as-is.
 *
 * The engine refuses with `{error, access}`: `access: "aggregate"` when the
 * page is not available at the caller's level, and `access: "unavailable"`
 * when it could not load who may see what (it then refuses everyone). Both
 * get plain words here, so no page has to know the wire format. Client-safe:
 * no server imports.
 */
export async function engineError(response: Response, fallback: string): Promise<Error> {
  const body = (await response.json().catch(() => ({}))) as { error?: string; access?: string };
  if (response.status === 403 && body.access === "unavailable") {
    return new Error(
      "Access levels could not be loaded just now, so nothing can be shown. Try again in a minute; if it keeps happening, tell Zack.",
    );
  }
  if (response.status === 403 && body.access) {
    return new Error("This page is not available at your access level.");
  }
  return new Error(body.error ?? fallback);
}
